export default __webpack_public_path__ + "273705f1f07ec4739645478a3af1b243.png";